import { PictureAndDescription } from "./App";

export const picturesAndDescriptions: PictureAndDescription[] = [
    {
      path: "beanandplutoonthebed.HEIC",
      key: "beanandplutoonthebed",
      description: "Bean and Pluto cuddled together on the bed"
    },
    {
      path: "beanbeingsillyinbed.JPEG",
      key: "beanbeingsillyinbed",
      description: "Bean being silly and playful in bed"
    },
    {
      path: "beanchillinginthewindow.JPEG",
      key: "beanchillinginthewindow",
      description: "Bean relaxing and chilling in the window"
    },
    {
      path: "beancozyinbed.jpeg",
      key: "beancozyinbed",
      description: "Bean looking cozy and comfortable in bed"
    },
    {
      path: "beanneutral.jpeg",
      key: "beanneutral",
      description: "Bean with a neutral, calm expression"
    },
    {
      path: "beanonbedwithtoys.jpeg",
      key: "beanonbedwithtoys",
      description: "Bean on the bed surrounded by toys"
    },
    {
      path: "beansayinghi.jpeg",
      key: "beansayinghi",
      description: "Bean greeting and saying hi"
    },
    {
      path: "beanserious.jpeg",
      key: "beanserious",
      description: "Bean with a serious, focused expression"
    },
    {
      path: "beanseriouswithhat.jpeg",
      key: "beanseriouswithhat",
      description: "Bean looking serious while wearing a hat"
    },
    {
      path: "beansillywithhat.jpeg",
      key: "beansillywithhat",
      description: "Bean being silly while wearing a hat"
    },
    {
      path: "beanwearingshoes.jpeg",
      key: "beanwearingshoes",
      description: "Bean adorably wearing shoes"
    },
    {
      path: "beanwithpluto.jpeg",
      key: "beanwithpluto",
      description: "Bean hanging out with Pluto"
    },
    {
      path: "beanwithplutogreeting.jpeg",
      key: "beanwithplutogreeting",
      description: "Bean and Pluto greeting together"
    },
    {
      path: "beanwithtongueout.JPEG",
      key: "beanwithtongueout",
      description: "Bean with tongue sticking out, being goofy"
    },
    {
      path: "beanyawning.jpeg",
      key: "beanyawning",
      description: "Bean mid-yawn, looking sleepy"
    }
  ];